import React from 'react'
import Home from '../components/Home'
import AboutsUs from '../components/AboutsUs'
import HowItWorks from '../components/HowItWork'
import ServicesComponent from '../components/ServicesComponent'
import WhyChooseUs from '../components/WhyChooseUs'
import TestimonialSection from '../components/Tetimonials'
import Faqs from '../components/Faqs'
import MemberShip from '../components/MemberShip'
import Footer from '../components/Footer'
import Contact from '../components/Contact'

function LandingPage() {
  return (
    <div className='overflow-x-hidden'>
    <div className='h-[70px]'></div>
    <Home />
    <AboutsUs />
    <HowItWorks />
    <WhyChooseUs />
    {/* <ServicesComponent /> */}
    <MemberShip />
    <TestimonialSection />
    <Faqs />
    <Contact />
    <Footer />
    </div>
  )
}

export default LandingPage